import React, { FC, MouseEventHandler } from 'react';
import * as yup from 'yup';
import { Form, Formik } from 'formik';
import { motion } from 'framer-motion';
import { DeliveryAddressesType } from '../../../models/delivery-addresses-type';
import FormText from '../../atoms/form-text/form-text';
import ButtonPrimary from '../../atoms/button-primary/button-primary';

interface Props extends DeliveryAddressesType {
  readonly numberOfAddressesShown: number;
  readonly numberOfAddressesTotal: number;
  readonly onAdd: MouseEventHandler<HTMLButtonElement>;
  readonly onSearch: (value: string | number) => void;
}

const DeliveryAddressesTop: FC<Props> = ({
  addAddressButtonText,
  numberOfAddressesShown,
  numberOfAddressesTotal,
  onAdd,
  onSearch,
  showingXResultsLabel,
  title,
  totalSavedAddressesFieldLabel,
}: Props) => {
  const totalAddressesLabel = totalSavedAddressesFieldLabel.replace(
    '{0}',
    `${numberOfAddressesTotal}`
  );
  const shownAddressesLabel = showingXResultsLabel
    .replace('{0}', `${numberOfAddressesShown}`)
    .replace('{1}', `${numberOfAddressesTotal}`);

  return (
    <div className="flex flex-col lg:flex-row items-center justify-between">
      <div className="flex flex-col items-center lg:items-start mb-6 lg:mb-0 text-center lg:text-left">
        <h4 className="page-heading-four lg:mb-8">{title}</h4>

        <motion.span
          animate={numberOfAddressesTotal ? 'show' : 'hide'}
          className="block text-grey-600"
          initial="hide"
          variants={{
            show: { opacity: 1 },
            hide: { opacity: 0 },
          }}
        >
          {numberOfAddressesShown === numberOfAddressesTotal
            ? totalAddressesLabel
            : shownAddressesLabel}
        </motion.span>
      </div>

      <div className="flex flex-col-reverse md:flex-row items-center md:items-end justify-between w-full lg:w-auto">
        <Formik
          initialValues={{
            searchTerm: '',
          }}
          validationSchema={yup.object({
            searchTerm: yup.string().label('Search addresses:'),
          })}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={null}
        >
          <Form className="w-full">
            <FormText
              label="Search addresses:"
              onChange={onSearch}
              name="searchTerm"
              placeholder="Search by any keyword"
              type="search"
            />
          </Form>
        </Formik>

        <div className="md:ml-6 mb-6 md:mb-0 w-full md:w-auto">
          <ButtonPrimary name={addAddressButtonText} onClick={onAdd} />
        </div>
      </div>
    </div>
  );
};

export default DeliveryAddressesTop;
